import React, {
  ComponentType,
  useEffect,
  useState
} from 'react'
import {
  Container,
  Grid
} from 'semantic-ui-react'
import filter from 'lodash/filter'
// Local
import {
  API_URL,
  USER_PROPERTY
} from '../../constant'
import { api } from '../../action/api'
import { propertyValue } from '../common/userPropertyUtils'
import {
  Property,
  User
} from '../authenticated/types'

const SafeGrid = Grid as unknown as ComponentType<any>

type Organization = {
  name: string
}

type UserPropertyDetailsProps = {
  currentUser: User
}

/**
 * Provides a component for displaying a user's user properties
 * @param currentUser Current user entity
 */
function UserPropertyDetails(
  props: UserPropertyDetailsProps
): JSX.Element | null {
  const { currentUser } = props
  const { userProperties } = currentUser

  const [
    organization,
    setOrganization
  ] = useState<Organization | null>(null)

  const fetchOrganization = (orgId: string) => {
    const url = API_URL.GET_ORGANIZATION(orgId)
    api.get(url, {}).then(({ data }) => {
      setOrganization(data as Organization)
    })
  }

  useEffect(() => {
    const orgId = propertyValue(userProperties, USER_PROPERTY.USER_PATIENT_ORG_FILTER)
    if (orgId) {
      fetchOrganization(orgId)
    }
  }, [])

  const withInterestingProperties = (properties: Property[]): Property[] => {
    if (properties && properties.length > 0) {
      return filter(
        properties,
        property =>
          property.propertyKey === USER_PROPERTY.USER_PATIENT_REGION_FILTER ||
          property.propertyKey === USER_PROPERTY.USER_PATIENT_ORG_FILTER
      )
    }
    return []
  }

  const regionFilterDetail = (property: Property) => (
    <Grid.Row key={ property.propertyKey }>
      <Grid.Column mobile={ 16 } tablet={ 16 } computer={ 16 }>
        <h4>Worklist Region Filtering</h4>
        <div>The following regions are applied to encounter worklists:</div>
        <ul>
          { String(property.propertyValue).split(',').map(region => (
            <li key={ region }>{ region.replaceAll('_', ' ') }</li>
          )) }
        </ul>
      </Grid.Column>
    </Grid.Row>
  )

  const organizationFilterDetail = (property: Property) => (
    <Grid.Row key={ property.propertyKey }>
      <Grid.Column mobile={ 16 } tablet={ 16 } computer={ 16 }>
        <h4>Worklist Organization Filtering</h4>
        <div>The following organization is applied to encounter worklists:</div>
        <ul>
          { organization ? (
            <li key={ String(property.propertyValue) }>{ organization.name }</li>
          ) : (
            <li key={ String(property.propertyValue) }>{ String(property.propertyValue) }</li>
          ) }
        </ul>
      </Grid.Column>
    </Grid.Row>
  )

  const renderUserPropertyDetail = (property: Property) => {
    if (property.propertyKey === USER_PROPERTY.USER_PATIENT_REGION_FILTER) {
      return regionFilterDetail(property)
    }
    if (property.propertyKey === USER_PROPERTY.USER_PATIENT_ORG_FILTER) {
      return organizationFilterDetail(property)
    }
    return null
  }

  const renderUserProperties = (properties: Property[]) => (
    <Container>
      <SafeGrid>
        { properties.map(property => renderUserPropertyDetail(property)) }
      </SafeGrid>
    </Container>
  )

  const interestingProperties = withInterestingProperties(userProperties)

  if (interestingProperties.length > 0) {
    return renderUserProperties(interestingProperties)
  }

  return null
}

export default UserPropertyDetails
